import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.CREATE_MEMBER_CARD:
    case actions.CREATE_ISSUED_MEMBER_CARD:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MEMBER_CARD_ENDED:
    case actions.CREATE_ISSUED_MEMBER_CARD_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.GET_MEMBER_CARDS_STATISTICS:
    case actions.SEARCH_MEMBER_CARDS:
    case actions.SEARCH_ISSUED_MEMBER_CARD_BATCHES:
    case actions.SEARCH_ISSUED_MEMBER_CARD_BATCH_ROWS:
    case actions.SEARCH_MEMBER_CARD_TRANSACTION_RECORDS:
    case actions.FIND_MEMBER_CARD:
      return {
        ...state,
        isSearching: true,
      };
    case actions.GET_MEMBER_CARDS_STATISTICS_ENDED:
    case actions.SEARCH_MEMBER_CARDS_ENDED:
    case actions.SEARCH_ISSUED_MEMBER_CARD_BATCHES_ENDED:
    case actions.SEARCH_ISSUED_MEMBER_CARD_BATCH_ROWS_ENDED:
    case actions.SEARCH_MEMBER_CARD_TRANSACTION_RECORDS_ENDED:
    case actions.FIND_MEMBER_CARD_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_MEMBER_CARD:
    case actions.UPDATE_ISSUED_MEMBER_CARD_BATCH:
    case actions.UPDATE_ISSUED_MEMBER_CARDS:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MEMBER_CARD_ENDED:
    case actions.UPDATE_ISSUED_MEMBER_CARD_BATCH_ENDED:
    case actions.UPDATE_ISSUED_MEMBER_CARDS_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    default:
      return state;
  }
};
